<template>
  <div class='leak-url-table-cell'>
    <v-badge
      tile
      overlap
      :icon="badgeIcon"
      :content="badgeContent"
      class="manual-config-badge"
      :class="{'copied-badge': displayedCopiedBadge}"
      :value="displayedCopiedBadge"
    >
      <div class="leak-url-table-cell__data" :title='url' @click='copyAsset'> {{ url }} </div>
    </v-badge>
    <div class="leak-url-table-cell__open">
      <custom-tooltip class="leak-url-table-cell-tooltip" placement="right" popper-class="light-tooltip">
        <div slot='buttonContent'>
          <v-btn  class="open-btn" :href="url" target="_blank">
            <v-icon>open_in_new</v-icon>
          </v-btn>
        </div>
        <div slot="content">
          <slot name="tooltip">
            <span>open</span>
          </slot>
        </div>
      </custom-tooltip>
    </div>
  </div>
</template>

<script>
import CustomTooltip from '@/components/common/CustomTooltip.vue';

export default {
  name: 'LeakUrlTableCell',
  components: {CustomTooltip},
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      displayedCopiedBadge: false,
    };
  },
  computed: {
    url() {
      return this.item[this.column.field];
    },
    badgeIcon() {
      return 'build';
    },
    badgeContent() {
      return this.$t('copied');
    },
  },
  methods: {
    async copyAsset() {
      const data = this.url;
      await navigator.clipboard.writeText(data);
      this.displayedCopiedBadge = true;
      await new Promise(resolve => setTimeout(resolve, 2000));
      this.displayedCopiedBadge = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/design-system';

.leak-url-table-cell {
  width: 100%;
  z-index: 2;
  .manual-config-badge {
    width: 85%;
    line-height: 1.5;
    &:hover {
      cursor: pointer;
    }
    .copied {
      text-transform: capitalize;
      color: $default-button-color;
    }
  }
  .leak-url-table-cell-tooltip {
    background-color: transparent;
  }
  &__open {
    margin-right: 5%;
  }
  &__data {
    width: 85%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__logo {
    max-width: rem(28);
    float: left;
    margin-top: $space-2;
    margin-right: $space-2;
    img {
      width: rem(28);
    }
  }
  .open-btn {
    background-color: transparent !important;
    box-shadow: none;
    letter-spacing: 1.07px;
    line-height: $font-size-md;
    text-align: center;
    text-transform: uppercase;
    min-width: rem(28);
    max-width: rem(28);
    min-height: rem(28);
    max-height: rem(28);
    color: $action-button-text-color;
    .v-icon {
      font-size: rem(22);
    }
  }
}
</style>

<style lang="scss">
@import '~@/assets/styles/design-system';

.leak-url-table-cell {
  .manual-config-badge {
    .v-badge__wrapper {
      .v-badge__badge {
        font-family: $font-family-medium !important;
        text-transform: capitalize;
        background: transparent !important;
        border: none !important;
        color: $default-button-color;
        .v-icon {
          font-size: $font-size-md;
          transform: rotate(180deg);
        }
      }
    }
    &.copied-badge {
      .v-badge__wrapper {
        .v-badge__badge {
          text-transform: capitalize;
          background: transparent !important;
          border: none !important;
          color: $default-button-color;
          right: rem(20) !important;
          inset: auto auto calc(100% - 1px) calc(100% - 30px) !important;
        }
      }
    }
  }
}
</style>
